import { StaticStoreItem } from "./static-store-item.model";

export class StaticStoreSource {
  source: string;
  itens: StaticStoreItem[];

  constructor(source: string, itens: StaticStoreItem[]) {
    this.source = source;
    this.itens = itens;
  }
}
